import { observer } from 'mobx-react-lite'
import { useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { useStore } from '~/app/store'
import { useToast } from '~/shared/lib'
import { useCurrentLegalEntityStores } from '~/shared/lib/hooks/use-current-legal-entity-stores'
import { Button, IconSave } from '~/shared/ui'
import { TabsValidationContext } from '~/shared/lib/contexts/tabs-validation-context/provider'
import {
  getCategoryFieldToTabMap,
  getCategoryValidationConfig,
} from '../lib/validation'

export const SaveCategory = observer(() => {
  const { t } = useTranslation()

  const toast = useToast()
  const navigate = useNavigate()

  const { pathname } = useLocation()

  const paths = pathname.split('/')
  const lastPath = paths[paths.length - 1]
  const isEditable = lastPath === 'edit'

  const { categoriesStore } = useStore()
  const stores = useCurrentLegalEntityStores()
  const { createCategoryData, saveCategory, isCreating, setIsErrorStoreId } =
    categoriesStore
  const { validateForm } = useContext(TabsValidationContext)
  const localizationKeys = useMemo(
    () => Object.keys(createCategoryData.localization || {}),
    [createCategoryData.localization],
  )
  const { storeId } = createCategoryData.category
  const hasValidCurrentStore =
    stores.length > 0 && stores.some((store) => store.id === storeId)

  const handleClick = () => {
    setIsErrorStoreId(false)

    if (!isEditable && !hasValidCurrentStore) {
      setIsErrorStoreId(true)
      return
    }

    const { fieldErrors } = validateForm(
      createCategoryData,
      getCategoryValidationConfig(localizationKeys, t),
      getCategoryFieldToTabMap(localizationKeys),
    )

    if (Object.keys(fieldErrors).length) {
      return
    }

    saveCategory(createCategoryData, createCategoryData.category.id).then(
      (res) => {
        if (res?.error?.length) {
          toast.open(res?.error, 'danger')
          return
        }

        const categoryStoreIdFilter = localStorage.getItem(
          'categoryStoreIdFilter',
        )
        navigate(`/categories?stores=${categoryStoreIdFilter}`)
      },
    )
  }

  return (
    <Button
      isLoading={isCreating}
      disabled={!isEditable && (!hasValidCurrentStore || isCreating)}
      intent="success"
      onClick={handleClick}
    >
      <IconSave />
      {isEditable ? t('save') : t('create')}
    </Button>
  )
})
